import { Component } from '@angular/core';

@Component({
  selector: 'app-sidepanel-content',
  imports: [],
  template: '<ng-content />',
  host: {
    class: 'px-md py-lg flex flex-col flex-1 overflow-y-auto gap-lg',
  },
})
export class SidepanelContentComponent {}
